import { PaymentTypeModel } from './payment-type.model';
import { NominalModel } from './nominal.model';

export class DepositBeanModel {
    public amount: number;
    public amountDue: number;
    public change: number;
    public reference: string;
    public type: PaymentTypeModel;
    public cashAccount: NominalModel;
    public date: string;
    public expiry: string;
    public note: string;

    public balanceOnAccount: number;
    public thisInvoice: number;
    public balancePlusThisInvoice: number;
    public lessDeposit: number;
    public totalDepositsHeld: number;
    public prevInvoices: number;

    [x: string]: any;
}
